import React, { useEffect, useState } from 'react';
import { useTasksContext } from '../../providers/TasksContextProvider';
import { useTaskListenerContext } from './TaskListenerContextProvider';
import ColorTag from './ColorTag';
import { createToggleHandler } from './Avoda';
import './TagsBar.css';

const TagsBar = () => {
  const {tags, setTags}   = useTasksContext();
  const {tasksChanged}    = useTaskListenerContext();
  const toggleTag = createToggleHandler(setTags);
  const [rendered, setRendered] = useState(null);


  useEffect(()=>{
    if (tags) {
      setRendered(tags);
    }
  },[tags, tasksChanged]);


  const compTagsList = rendered ? Object.entries(rendered).map(([tag, status]) => <ColorTag title={tag} key={tag} clickMe={() => toggleTag(tag)} isActive={status.isSelected}/>) : null;

  return (
    <div className='tagsBar'>
      {compTagsList}
    </div>
  );
};

export default TagsBar;